/**
 * Lightweight analytics bridge. Wire `gtag` / `dataLayer` in production when available.
 */
export function trackEvent(eventName: string, payload: Record<string, unknown>): void {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console -- intentional observability in dev
    console.info("[analytics]", eventName, payload)
  }

  const w = window as unknown as {
    gtag?: (command: string, target: string, params?: Record<string, unknown>) => void
    dataLayer?: Array<Record<string, unknown>>
  }

  if (typeof w.gtag === "function") {
    w.gtag("event", eventName, payload)
    return
  }

  if (Array.isArray(w.dataLayer)) {
    w.dataLayer.push({ event: eventName, ...payload })
  }
}
